module.exports = __webpack_public_path__ + "static/01-0ca452c5a3881108025637e0fc050844.jpg";